import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("UI error caught by boundary:", error, info);
  }

  reset = () => this.setState({ error: null });

  render() {
    if (this.state.error) {
      return (
        <div className="border border-destructive/30 bg-destructive/5 p-8 max-w-xl" data-testid="error-boundary">
          <h2 className="font-heading text-xl font-semibold tracking-tight text-destructive">Something went wrong on this screen</h2>
          <p className="text-sm text-muted-foreground mt-2">
            The rest of the app is still running. Try reloading this section — if it keeps happening, refresh the page.
          </p>
          <pre className="mt-4 text-xs font-mono bg-secondary/60 border border-border p-3 overflow-auto max-h-40 whitespace-pre-wrap">
            {String(this.state.error?.message || this.state.error)}
          </pre>
          <div className="mt-4 flex gap-2">
            <button onClick={this.reset} className="px-4 py-2 text-sm bg-primary text-primary-foreground" data-testid="error-retry">Try again</button>
            <button onClick={() => window.location.reload()} className="px-4 py-2 text-sm border border-border" data-testid="error-reload">Reload page</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
